import { Modal } from "../../components/Modal/Modal";
import { ModalOverlay } from "../../components/Modal/ModalOverlay";
import "keen-slider/keen-slider.min.css";
import { Carousel } from "./Carousel";
// import "./onboarding.css";
import useEmblaCarousel from "embla-carousel-react";
import clsx from "clsx";
import bgOnboarding from "../../assets/bg-modal-1.png";
import bgOnboarding2 from "../../assets/bg-modal-2.png";
import Lockup from "../../assets/cba-logo.png";

type OnboardingModalsProps = {
  onClose: () => void;
  firstSlideOnly?: boolean;
};

export const OnboardingModals = ({
  onClose,
  firstSlideOnly = false,
}: OnboardingModalsProps) => {
  const carouselOptions = {
    loop: false,
    draggable: true,
  };

  const [carouselRef, emblaApi] = useEmblaCarousel(carouselOptions);

  const goToNextSlide = () => {
    if (emblaApi) emblaApi.scrollNext();
  };

  return (
    <ModalOverlay>
      <Modal
        maxWidth="max-w-[350px]"
        maxHeight="max-h-[520px]"
        className="bg-cover text-white centered w-[92%] overflow-hidden bg-white animate-fade-in"
      >
        <Carousel
          options={carouselOptions}
          carouselRef={carouselRef}
          emblaApi={emblaApi}
        >
          <div
            className="flex flex-col justify-between h-full w-full bg-cover pt-[25px] px-[30px] pb-[68px] bg-top"
            style={{
              backgroundImage: `url(${bgOnboarding})`,
            }}
          >
            <div className="flex flex-col gap-[24px] text-black">
              <img src={Lockup} className="max-w-[45px] w-full " />
              <div
                className={clsx(
                  "flex flex-col justify-end gap-[16px] pb-[18px] w-full h-full animate-fade-in xopacity-0"
                )}
              >
                <h2 className=" font-cba-sans-bold text-[30px] leading-[30px]">
                  General
                  <br />
                  Insurance <br /> Reimagined
                </h2>
                <p className="font-source-serif-pro text-[20px] leading-[22px] italic">
                  AR Experience
                </p>
              </div>
              <p className="font-cba-sans text-[18px] leading-[22px] pb-[12px] flex-grow">
                Welcome to the Clever Cube. Discover the latest insurance
                products, provided by Hollard, and help protect the things that
                matter.
              </p>
            </div>
            <button
              className="mx-auto relative max-w-[210px] w-full h-[50px] border text-[#3A3A3A] text-base font-cba-sans-extrabold border-black rounded-full active:opacity-70 "
              onClick={firstSlideOnly ? onClose : goToNextSlide}
            >
              {firstSlideOnly ? "OK" : "Next"}
            </button>
          </div>
          {!firstSlideOnly && (
            <div
              className={
                "relative flex flex-col justify-between h-full w-full bg-cover pt-[77px] pl-[30px] pr-[35px] pb-[68px] overflow-auto bg-[#ECECEC]"
              }
              style={{
                backgroundImage: `url(${bgOnboarding2})`,
              }}
            >
              <div className="flex flex-col flex-grow justify-between">
                <p class="font-cba-sans text-[18px] leading-[22px] text-black">
                  You are about to view an augmented reality cube.
                  <br />
                  Please follow the next steps to activate the experience.
                  <br />
                  <br />
                  Please note that the Insurance products are subject to
                  Hollard's acceptance criteria. Terms, Conditions and
                  Exclusions apply. Read the Product Disclosure Statement (PDS)
                  for more information.
                </p>
              </div>
              <button
                className="mx-auto relative max-w-[210px] w-full h-[50px] border text-[#3A3A3A] text-base font-cba-sans-extrabold border-black rounded-full active:opacity-70 "
                onClick={onClose}
              >
                Acknowledge
              </button>
            </div>
          )}
        </Carousel>
      </Modal>
    </ModalOverlay>
  );
};
